import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import FormField from "../ui/FormField";

interface AddSunbedModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (label: string) => void;
  existingLabel?: string;
  mode: "add" | "edit";
}

export const AddSunbedModal = ({
  isOpen,
  onClose,
  onSave,
  existingLabel = "",
  mode,
}: AddSunbedModalProps) => {
  const [label, setLabel] = useState("");

  useEffect(() => {
    if (isOpen) {
      setLabel(existingLabel || "");
    }
  }, [isOpen, existingLabel]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(label);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black/40 z-50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-xl shadow-lg w-full max-w-lg p-0 flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="px-6 py-4 border-b border-[#885ABB] flex justify-between items-center bg-[#885ABB] rounded-t-xl">
          <h2 className="text-xl font-bold text-white">
            {mode === "add" ? "Add Sunbed Room" : "Edit Sunbed Room"}
          </h2>
          <button 
            onClick={onClose} 
            className="text-white/80 hover:text-white hover:bg-white/10 p-1 rounded-full transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        {/* Content */}
        <form onSubmit={handleSubmit} className="px-6 py-6 space-y-6">
          <FormField
            label="Room Label"
            name="label"
            value={label}
            onChange={(_, val) => setLabel(val)}
            placeholder="e.g. Room 1"
            className="w-full"
          />

          <div className="flex justify-end gap-3 pt-4 border-t border-gray-100">
             <button
               type="button"
               onClick={onClose}
               className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
             >
               Cancel
             </button>
             <button
               type="submit"
               className="bg-[#885ABB] hover:bg-[#6f47a2] text-white font-medium px-6 py-2 rounded-lg transition-colors shadow-sm"
             >
               Save
             </button>
          </div>
        </form>
      </div>
    </div>
  );
};
